export const getFormHistoryIsOpen = (state) => state.formHistory.isOpen;
export const getFormHistoryRows = (state) => state.formHistory.rows;
